import React from "react";
import { Switch, Route } from 'react-router-dom';
import Login from "./login";

import "./passport.scss";

export default class Passport extends React.PureComponent {
    // constructor(props: any) {
    //     super(props);
    // }
    render() {
        return (
            <>
                <div className="pspt">
                    <h1 className="site-name">CMS</h1>

                    <div className="left-tip">
                        <div className="tip-head"></div>
                        <p className="tip-body"></p>
                    </div>

                    <div className="right-content">
                        <Switch>
                            <Route path="/" component={Login} />
                            <Route path="/login" component={Login} />
                        </Switch>
                    </div>
                </div>
            </>
        );
    }
}
